var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertHexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.00011V7.50011M7.5 10.0001H7.50625M1.875 4.96352V10.0367C1.875 10.2509 1.875 10.3579 1.90655 10.4534C1.93447 10.5379 1.9801 10.6155 2.0404 10.6809C2.10855 10.7549 2.20215 10.8069 2.38936 10.9109L7.01436 13.4803C7.19161 13.5788 7.28024 13.628 7.37409 13.6473C7.45716 13.6644 7.54284 13.6644 7.62591 13.6473C7.71976 13.628 7.80839 13.5788 7.98564 13.4803L12.6106 10.9109C12.7978 10.8069 12.8914 10.7549 12.9596 10.6809C13.0199 10.6155 13.0655 10.5379 13.0934 10.4534C13.125 10.3579 13.125 10.2509 13.125 10.0367V4.96352C13.125 4.74937 13.125 4.64229 13.0934 4.54679C13.0655 4.4623 13.0199 4.38475 12.9596 4.31932C12.8914 4.24536 12.7978 4.19336 12.6106 4.08936L7.98564 1.51992C7.80839 1.42144 7.71976 1.3722 7.62591 1.3529C7.54284 1.33582 7.45716 1.33582 7.37409 1.3529C7.28024 1.3722 7.19161 1.42144 7.01436 1.51992L2.38936 4.08936C2.20215 4.19336 2.10855 4.24536 2.0404 4.31932C1.9801 4.38475 1.93447 4.4623 1.90655 4.54679C1.875 4.64229 1.875 4.74936 1.875 4.96352Z",
    stroke: "#5A52C3",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertHexIcon);
export default __webpack_public_path__ + "static/media/alertHexIcon.3230251c7b828beb9084ce9ca928404b.svg";
export { ForwardRef as ReactComponent };